import { z } from 'zod';

export const imageVariantSchema = z.object({
  name: z.string(),
  width: z.number(),
  height: z.number().optional(),
  fit: z.enum(['cover', 'inside']),
  format: z.enum(['webp', 'jpeg', 'png', 'avif']),
  quality: z.number().optional(),
});

export const prefixRuleSchema = z.object({
  pattern: z.string(),
  visibility: z.enum(['PUBLIC', 'PRIVATE']).optional(),
  maxSizeBytes: z.number().optional(),
  allowedMimeTypes: z.array(z.string()).optional(),
  expiresAfterSeconds: z.number().optional(),
  image: z
    .object({
      variants: z.array(imageVariantSchema),
      stripMetadata: z.boolean().optional(),
      extractGps: z.boolean().optional(),
    })
    .optional(),
});
export type PrefixRule = z.infer<typeof prefixRuleSchema>;

export const appSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.enum(['ACTIVE', 'ORPHAN']),
  storageQuotaBytes: z.number().nullable(),
  managedBy: z.string().nullable(),
  prefixRules: z.array(prefixRuleSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type App = z.infer<typeof appSchema>;

export const statsSchema = z.object({
  appId: z.string(),
  bytesUsed: z.string(),
  fileCount: z.number(),
  pendingCount: z.number(),
  quotaBytes: z.number().nullable(),
  quotaUsedPercent: z.number().nullable(),
});
export type AppStats = z.infer<typeof statsSchema>;
